import React, { Component } from "react";
import Box from "@mui/material/Box";
import Sidebar from "../Sidebar";
import {
  Divider,
  Paper,
  Typography,
  LinearProgress,
  Button,
  Grid,
  requirePropFactory,
  Backdrop,Switch
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import CloseIcon from "@mui/icons-material/Close";
import {
  Tooltip,
  IconButton,
  Modal,
  TableBody,
  Table,
  TableContainer,
  TablePagination,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  InputAdornment,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import base_url from "../base.json";
import "react-datepicker/dist/react-datepicker.css";
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import ReadMoreIcon from  '@mui/icons-material/ReadMore';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import loader from '../img/ltm.gif'
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon  from '@mui/icons-material/FileCopyOutlined';
import SupervisorAccountOutlinedIcon  from '@mui/icons-material/Diversity1Outlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import base from '../../src/base.json'


const drawerWidth = 80;
export class JobList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      

     builderList : [],
     page : 0,
     rowsPerPage : 10,
     builderCount : 0,



       is_frenchise_delete : false,
       is_loader_shows : false,
       f_id  :""
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSearchChange = (e) => {
   
  };



  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      this.instantRetrive();
    });
  };



  handleChangeRowsPerPage = (event) => {
    this.setState(
      { rowsPerPage: parseInt(event.target.value, 10), page: 0 },
      () => {
        this.instantRetrive();
      }
    );
  };



  componentDidMount() {
    //// retrive leads list here for display
    
      fetch(
           `${base.base_url}/job_portal/admin/jobs/retriveJobList/:${this.state.page}/:${this.state.rowsPerPage}`,
           {
              headers: {
                      "Content-Type":"application/json"
                        },
             method: "get",
           }
         )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
             this.setState({
               builderList: result.data,
               builderCount: result.size,
               is_loader_shows : false
             });
           });
     
  }




  instantRetrive = () => {
  
      fetch(
           `${base.base_url}/job_portal/admin/jobs/retriveJobList/:${this.state.page}/:${this.state.rowsPerPage}`,
           {headers: {
                      "Content-Type":"application/json"
                        },
             method: "get",
           }
          )
           .then((res) => {
             return res.json();
           })
           .then((result) => {
             this.setState({
               builderList: result.data,
               builderCount: result.size,
               is_loader_shows : false
             });
           });
     

  };



sucessfull=(data)=>{
    toast.success(data, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      //transition: Bounce,
      });
  }


  render() {
    return (
      <Box sx={{ display: "flex" }}>
        <Sidebar />
        <Box
          sx={{ width: { sm: `calc(100% - ${drawerWidth}px)`, xs: "100%" } }}
        >
          <Box sx={{ height: "100%", width: "100%" }}>
            {
              /// header data
            }
            <Box
              sx={{
                height: 47,
                width: "100%",
                backgroundColor: "#fff",
                borderRadius: 0,
                mt: 0.2,
                borderBottom: 0.5,
                borderBottomColor: "#dddddd",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: 18, ml: 1 }}>Job List </Typography>
            </Box>

       

      
            <Box sx={{ paddingLeft: 3, paddingRight: 3, paddingTop: 2,display:this.state.is_loader_shows?'none':'block' }}>

    
              <Box sx={{ mt: 2, padding: 0 }}>
                <Paper
                  variant="outlined"
                  sx={{ minHeight: 250, width: "100%" }}
                >
                  <TableContainer
                    component={Box}
                    sx={{ backgroundColor: "#f4f4f6" }}
                  >
                    <Table
                      sx={{ minWidth: 620 }}
                      size="small"
                      aria-label="a dense table"
                    >
                        <TableHead>
                        <TableRow>

                               <TableCell
                            align="left"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Company
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Job Name
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Posted at
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                          Company Type
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Job City
                          </TableCell>

                               <TableCell
                            align="center"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Salary
                          </TableCell>

                          
                               <TableCell
                            align="center"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                           Work Mode
                          </TableCell>
                   
                  
                          <TableCell
                            align="right"
                            sx={{
                              fontSize: 13,
                              fontWeight: "600",
                              color: "#008ffb",
                            }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.builderList.map((row, index) => (
                             <TableRow
                                                    key={row._id}
                                                    sx={{
                                                      "&:last-child td, &:last-child th": { border: 0 },
                                                      backgroundColor: index % 2 ? "#f9f9f9" : "#fff",
                                                    }}
                                                  >
                                                     <TableCell
                                                      component="th"
                                                      scope="row"
                                                      sx={{ color: "#42526e" }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          height: 20,
                                                          minWidth: 60,
                                                          display: "flex",
                                                          justifyContent: "left",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            paddingLeft: 1,
                                                            paddingRight: 1,
                                                          }}
                                                        >
                                                         {row.company_name}
                                                        </Typography>
                                                      </Box>
                                                    </TableCell>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                      sx={{ color: "#42526e" }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          height: 20,
                                                          minWidth: 60,
                                                          display: "flex",
                                                          justifyContent: "left",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                            paddingLeft: 1,
                                                            paddingRight: 1,
                                                          }}
                                                        >
                                                         {row.job_name}
                                                        </Typography>
                                                      </Box>
                                                    </TableCell>
                        
                                                    <TableCell
                                                      align="left"
                                                      sx={{
                                                        color: "#42526e",
                                                        textTransform: "uppercase",
                                                        minWidth: 100,
                                                      }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          height: 20,
                                                          minWidth: 60,
                                                          display: "flex",
                                                          justifyContent: "left",
                                                          alignItems: "center",
                                                        }}
                                                      >
                                                        <Typography
                                                          sx={{
                                                            fontSize: 11,
                                                            fontWeight: "500",
                                                            paddingLeft: 1,
                                                            paddingRight: 1,
                                                          }}
                                                        >
                                                       {row.posted_at}
                                                        </Typography>
                                                      </Box>
                                                    </TableCell>
                        
                                                    <TableCell
                                                      align="center"
                                                      sx={{
                                                        color: "#42526e",
                                                        textTransform: "capitalize",
                                                        fontSize: 11,
                                                        fontWeight:'500'
                                                      }}
                                                    >
                                                        {row.company_type}
                                                    </TableCell>
                        
                                                    <TableCell
                                                      align="center"
                                                      sx={{
                                                        color: "#42526e",
                                                        textTransform: "capitalize",
                                                        fontSize: 11,
                                                        fontWeight:'500'
                                                      }}
                                                    >
                                                       {row.job_city}
                                                    </TableCell>
                        
                                                    <TableCell
                                                      align="center"
                                                      sx={{
                                                        color: "#42526e",
                                                        textTransform: "capitalize",
                                                        fontSize: 11,
                                                        fontWeight:'500'
                                                      }}
                                                    >
                                                       {row.salary} INR
                                                    </TableCell>
                        
                                                     <TableCell
                                                      align="center"
                                                      sx={{
                                                        color: "#42526e",
                                                        textTransform: "capitalize",
                                                        fontSize: 11,
                                                        fontWeight:'500'
                                                      }}
                                                    >
                                                       {row.work_mode}
                                                    </TableCell>
                        
                                      
                                                    <TableCell align="right">
                                                      <Box
                                                        sx={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                          justifyContent: "right",
                                                        }}
                                                      >
                        
                                                        
                                                                                 
                                                
                                                      <Tooltip title="DELETE">
                                                          <IconButton size="small" onClick={()=>{
                                                            this.setState({
                                                              f_id : row._id,
                                                              is_frenchise_delete :true
                                                            })
                                                          }}>
                                                            <DeleteOutlinedIcon
                                                              sx={{
                                                                color: "red",
                                                                height: 17,
                                                                width: 17,
                                                              }}
                                                            />
                                                          </IconButton>
                                                        </Tooltip>
                        
                        
                                                                                  <Tooltip title="Job Application">
                                                                                          <Link to={`/jobApplicationList/:${row._id}`}>
                                                                                          <IconButton size="small" >
                                                                                            <ReadMoreIcon
                                                                                              sx={{
                                                                                                color: "#00cfe8",
                                                                                                height: 17,
                                                                                                width: 17,
                                                                                              }}
                                                                                            />
                                                                                          </IconButton>
                                                                                          </Link>
                                                                                        </Tooltip>
                        
                                                      </Box>
                                                    </TableCell>
                                                  </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Divider />
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={this.state.builderCount}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </Paper>
              </Box>



            </Box>
          </Box>
        </Box>










{
  //// delte vendor details
}


  <Box>
          <Modal
            open={this.state.is_frenchise_delete}
            onClose={this.handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <Paper
                sx={{
                  width: { xs: "90%", sm: "90%", md: "25%", lg: "25%" },
                  height: "35vh",
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "right",
                  }}
                >
                  <Box
                    sx={{
                      height: 40,
                      backgroundColor: "#f29494",
                      width: "100%",
                      borderTopLeftRadius: 5,
                      borderTopRightRadius: 5,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: 15,
                        color: "#fff",
                        mt: 1,
                        ml: 1,
                        fontWeight: "500",
                      }}
                    >
                      Confirm Deletation
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      height: 50,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                    }}
                  >
                    <WarningAmberOutlinedIcon
                      sx={{ height: 35, width: 35, color: "#f29494" }}
                    />
                  </Box>

                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    Are you sure want to delete this item?.
                  </Typography>
                  <Typography textAlign="center" sx={{ fontSize: 13 }}>
                    This action cannot be undone.
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      mt: 3,
                      justifyContent: "right",
                    }}
                  >
                    <Button
                      small="small"
                      variant="outlined"
                      onClick={() =>
                        this.setState({ is_frenchise_delete: false })
                      }
                      sx={{ fontSize: 10 }}
                    >
                      Cancel
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      variant="contained"
                      sx={{ fontSize: 10, ml: 1, mr: 3 }}
                      onClick={() => {
                        fetch(`${base.base_url}/job_portal/admin/jobs/deleteJob_users`, {
                          headers: {
                            "content-type": "application/json",
                          },
                          method: "delete",
                          body: JSON.stringify({
                            _id: this.state.f_id,
                          }),
                        })
                          .then((res) => {
                            return res.json();
                          })
                          .then(() => {
                            this.setState({
                              f_id: "",
                              is_frenchise_delete : false,
                            });
                            this.instantRetrive();
                            this.sucessfull("Deleted sucessfull");
                          });
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Modal>
        </Box>











        <Backdrop
   sx={(theme) => ({ backgroundColor:'transparent', zIndex: theme.zIndex.drawer + 1 })}
  open={this.state.is_loader_shows}
  onClick={this.handleClose}
>
<Paper elevation={0} sx={{height:70,width:70,display:'flex',justifyContent:'center',alignItems:'center'}}>
<img  src={loader} style={{height:67,width:67}}/>
</Paper>
</Backdrop>

        
                <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        //transition={Bounce}
        />
      </Box>
    );
  }
}

export default JobList;


export function JobListc(props){
  const navigate = useNavigate();
  const location = useLocation();
  const param = useParams()
  return (<JobList param={param} navigate={navigate}></JobList>)}


